<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="disabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <a-form-item :label="$t('label.poultrySeedlings')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['poultryQty', validatorRules.poultryQty]" :placeholder="$t('label.pleaseEnterPoultrySeedlings')"
                              style="width: 84%" disabled/>
{{ $t('label.featherKg') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.mortality')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['deadQty', validatorRules.deadQty]" :placeholder="$t('label.pleaseEnterTheMortaility')"
                              style="width: 84%" disabled/>
{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.numberOfGifts')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['giveQty', validatorRules.giveQty]" :placeholder="$t('label.pleaseEnterTheNumberOfGifts')"
                              style="width: 84%" disabled/>
              {{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.amountOfDoc')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['poultryPrice', validatorRules.poultryPrice]" :placeholder="$t('label.pleaseEnterTheAmountOfDoc')"
                              style="width: 84%" @change="poultryPriceChanged"/>
              {{ $t('label.yuan') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.feedConsumption')":labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['feedQty', validatorRules.feedQty]" :placeholder="$t('label.pleaseEnterTheAmountOfFeedConsumed')"
                              style="width: 84%" disabled/>
              kg
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.amountOfFeed')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['feedPrice', validatorRules.feedPrice]" :placeholder="$t('label.pleaseEnterTheAmountOfFeed')"
                              style="width: 84%" disabled/>
              {{ $t('label.yuan') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.amountOfMedicineConsumption')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['drugPrice', validatorRules.drugPrice]" :placeholder="$t('label.pleaseEnterTheAmountOfMedicineConsumption')"
                              style="width: 84%" disabled/>
              {{ $t('label.yuan') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.amountOfVaccineConsumption')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['immuPrice', validatorRules.immuPrice]" :placeholder="$t('label.pleaseEnterTheAmountOfVaccineConsumption')"
                              style="width: 84%" disabled/>
              {{ $t('label.yuan') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.totalAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['totalPrice', validatorRules.totalPrice]" :placeholder="$t('label.pleaseEnterTheTotalAmount')"
                              style="width: 84%" disabled/>
              {{ $t('label.yuan') }}
            </a-form-item>
          </a-col>
          <!--          <a-col :span="8">-->
          <!--            <a-form-item v-has="'buffer3'" label="其他成本 元/只" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
          <!--              <a-input-number v-decorator="['buffer3', {'initialValue': '1'}]" placeholder="请输入其他成本 元/只" style="width: 100%"/>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
        </a-row>
      </a-form>
    </j-form-container>
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="$t('tabName.requisitionStatistics')" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="efsStBreedSettleExpendListTable.loading"
          :columns="efsStBreedSettleExpendListTable.columns"
          :dataSource="efsStBreedSettleExpendListTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"/>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>
<script>
    import pick from 'lodash.pick'
    import { getAction } from '@/api/manage'
    import { validateDuplicateValue } from '@/utils/util'
    import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
    import JFormContainer from '@/components/jeecg/JFormContainer'
    import JDate from '@/components/jeecg/JDate'
    import JDictSelectTag from '@/components/dict/JDictSelectTag'
    import { FormTypes, getRefPromise } from '@/utils/JEditableTableUtil'

    export default {
        name: 'SettleExpendListForm',
        mixins: [JEditableTableMixin],
        components: {
            JFormContainer,
            JDate,
            JDictSelectTag,
        },
        props: {
            //流程表单data
            formData: {
                type: Object,
                default: () => {
                },
                required: false
            },
            //表单模式：false流程表单 true普通表单
            formBpm: {
                type: Boolean,
                default: false,
                required: false
            },
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data() {
            return {
                model: {},
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 6 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                },
                labelCol2: {
                    xs: { span: 24 },
                    sm: { span: 3 },
                },
                wrapperCol2: {
                    xs: { span: 24 },
                    sm: { span: 20 },
                },
                validatorRules: {
                    poultryQty: {
                        rules: [
                            { required: true, message: '请输入禽苗数!' },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    deadQty: {
                        rules: [
                            { required: true, message: '请输入死淘数!' },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    giveQty: {
                        rules: [
                            { required: true, message: '请输入赠送数!' },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    poultryPrice: {
                        rules: [
                            { required: true, message: '请输入禽苗金额!' },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    feedQty: {
                        rules: [
                            { required: true, message: '请输入饲料耗用量!' },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    feedPrice: {
                        rules: [
                            { required: true, message: '请输入饲料金额!' },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    drugPrice: {
                        rules: [
                            { required: true, message: '请输入药品耗用金额!' },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    immuPrice: {
                        rules: [
                            { required: true, message: '请输入疫苗耗用金额!' },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    totalPrice: {
                        rules: [
                            { required: true, message: '请输入合计金额!' },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                },
                refKeys: ['efsStBreedSettleExpendList',],
                tableKeys: ['efsStBreedSettleExpendList',],
                activeKey: 'efsStBreedSettleExpendList',
                // 合同价格清单详情
                efsStBreedSettleExpendListTable: {
                    loading: false,
                    dataSource: [],
                    columns: [
                        // {
                        //     title: '日期',
                        //     key: 'postDate',
                        //     type: FormTypes.date,
                        //     width: '150px',
                        //     disabled: true,
                        //     placeholder: '请输入${title}',
                        //     defaultValue: '',
                        // },
                        {
                            title: this.$t('tableHeader.materialCode'),
                            key: 'mmCode',
                            type: FormTypes.normal,
                            width: '180px',
                        },
                        {
                            title: this.$t('tableHeader.materialName'),
                            key: 'mmName',
                            type: FormTypes.normal,
                            width: '300px',
                        },
                        // {
                        //     title: '规格',
                        //     key: 'spe',
                        //     type: FormTypes.input,
                        //     width: '100px',
                        //     placeholder: '请输入${title}',
                        //     defaultValue: '',
                        // },
                        {
                            title: this.$t('tableHeader.unit'),
                            key: 'unit',
                            type: FormTypes.normal,
                            width: '100px',
                        },
                        {
                            title: this.$t('tableHeader.quantity'),
                            key: 'qty',
                            type: FormTypes.normal,
                            width: '100px',
                        },
                        {
                            title: this.$t('tableHeader.unitPrice'),
                            key: 'unitPrice',
                            type: FormTypes.normal,
                            width: '100px',
                        },
                        {
                            title: this.$t('tableHeader.amount'),
                            key: 'amount',
                            type: FormTypes.normal,
                            width: '100px',
                        },
                    ]
                },
                url: {
                    efsMdContractPriceListDetail: {
                        list: '/newContractManage/efsMdContract/queryEfsMdContractPriceListDetailByChangeMainId'
                    },
                },
                poultryPriceOld:0,
            }
        },
        computed: {
            formDisabled() {
                if (this.formBpm === true) {
                    if (this.formData.disabled === false) {
                        return false
                    }
                    return true
                }
                return this.disabled
            },
            showFlowSubmitButton() {
                if (this.formBpm === true) {
                    if (this.formData.disabled === false) {
                        return true
                    }
                }
                return false
            }
        },
        methods: {
            initFormData(url, id) {
                this.clearFormData()
                if (!id) {
                    this.edit({})
                } else {
                    getAction(url, { id: id }).then(res => {
                        if (res.success) {
                            let records = res.result
                            this.efsStBreedSettleExpendListTable.dataSource = res.result.efsBreedSettleExpendVoList
                            this.edit(records)
                        }
                    })
                }
            },
            formDataByBreedCode(url, code) {
                getAction(url, { breedCode: code }).then(res => {
                    if (res.success) {
                        this.form.setFieldsValue({
                            poultryQty: res.result.poultryQty,
                            deadQty: res.result.deadQty,
                            giveQty: res.result.giveQty,
                            poultryPrice: res.result.poultryPrice,
                            feedQty: res.result.feedQty,
                            feedPrice: res.result.feedPrice,
                            drugPrice: res.result.drugPrice,
                            immuPrice: res.result.immuPrice,
                            totalPrice: res.result.totalPrice,
                        })
                        this.efsStBreedSettleExpendListTable.dataSource = res.result.efsBreedSettleExpendVoList;
                        this.$bus.$emit("expendPriceEmit", res.result.totalPrice);
                        this.poultryPriceOld=res.result.poultryPrice;
                    }
                })

            },
            getAllTable() {
                let values = this.tableKeys.map(key => getRefPromise(this, key))
                return Promise.all(values)
            },
            edit(record) {
                this.model = Object.assign({}, record)
                let fieldval = pick(this.model, 'poultryQty', 'deadQty', 'giveQty', 'poultryPrice', 'feedQty', 'feedPrice', 'drugPrice', 'immuPrice', 'totalPrice', 'price', 'unitPrice', 'qty', 'unit', 'spe', 'mmName', 'mmCode')
                if (this.model.id) {
                    let params = { conCode: this.model.conCode }
                    this.requestSubTableData(this.url.efsStBreedSettleExpendListTable.list, params, this.efsStBreedSettleExpendListTable)
                }
                this.$nextTick(() => {
                    this.form.setFieldsValue(fieldval)
                })
            },
            getFormData() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        if (!this.efsStBreedSettleExpendListTable.dataSource) {
                            this.$emit('validateError', '耗用明细不能为空！')
                        }
                        let formdata = Object.assign(this.model, values)
                        this.efsStBreedSettleExpendListTable.dataSource.map((item, index) => {
                            item.poultryQty = formdata.poultryQty
                            item.deadQty = formdata.deadQty
                            item.giveQty = formdata.giveQty
                            item.poultryPrice = formdata.poultryPrice
                            item.feedQty = formdata.feedQty
                            item.feedPrice = formdata.feedPrice
                            item.drugPrice = formdata.drugPrice
                            item.immuPrice = formdata.immuPrice
                            item.totalPrice = formdata.totalPrice
                        })
                    } else {
                        this.$emit('validateError', '耗用明细校验未通过')
                        return;
                    }
                })
                return this.efsStBreedSettleExpendListTable.dataSource
            },
            popupCallback(row) {
                this.form.setFieldsValue(pick(row, 'chickCost', 'feedCost', 'drugCost'))
            },
            clearFormData() {
                this.form.resetFields()
                this.model = {}
                this.efsStBreedSettleExpendListTable.dataSource = []
            },
            poultryPriceChanged(poultryPrice){
                //剩余合计金额
                let totalPrices=this.form.getFieldValue('totalPrice');
                if(totalPrices==undefined){
                    totalPrices=0;
                }
                let totalPrice= totalPrices-this.poultryPriceOld;
                this.form.setFieldsValue({totalPrice:(Number(totalPrice)+Number(poultryPrice)).toFixed(2)});
                this.poultryPriceOld=poultryPrice;
            }
        }
    }


</script>

<style>
  .input-table .tbody .td {
    height: 44px;
  }
</style>